var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipetteRackM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 174,
    viewBox: "0 0 135 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.91 172.729L130.607 172.615C132.606 172.604 134.217 171.405 134.209 169.934L134.154 159.817C134.145 158.312 132.426 157.096 130.333 157.177L108.64 158.102L109.91 172.729Z",
    fill: "#A6A6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.348 0.347618L114.248 0.180577C115.913 0.101383 117.346 1.03873 117.448 2.26349L130.38 157.177L114.824 157.823L109.348 0.347618Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.865 172.751L126.563 172.637C128.561 172.626 130.173 171.427 130.165 169.957L130.11 159.979C130.102 158.474 128.382 157.258 126.289 157.34L104.644 158.264L105.865 172.751Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.305 0.475183L110.253 0.342888C111.918 0.298702 113.303 1.23631 113.404 2.42606L126.336 157.305L110.833 158.826L105.305 0.475183Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2565 173.596L4.41604 173.711C2.51281 173.722 0.936324 172.575 0.928675 171.175L0.87207 160.812C0.864038 159.342 2.52306 158.178 4.47426 158.237L26.3183 158.922L25.2565 173.596Z",
    fill: "#A6A6A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9342 1.21925L18.2235 1.07567C17.0338 1.04722 15.9907 1.71814 15.9481 2.62861L4.61718 158.271L20.1792 158.746L23.9342 1.21925Z",
    fill: "#A6A6A6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3008 173.574L8.46032 173.689C6.55708 173.699 4.9806 172.553 4.97295 171.152L4.91711 160.93C4.90908 159.46 6.5681 158.295 8.5193 158.355L30.3633 159.039L29.3008 173.574Z",
    fill: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.979 1.30228L22.221 1.19398C21.0313 1.16552 20.0359 1.87119 19.9455 2.74691L8.66222 158.389L24.182 159.844L27.979 1.30228Z",
    fill: "#D9D9D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.012 50.8357L21.3554 51.8215L23.4734 22.4023L111.393 21.4425L114.012 50.8357Z",
    fill: "#89A9BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipetteRackM);
export default __webpack_public_path__ + "static/media/pipette_rack_m.e21d3a56f32e900c7c966454bc735b22.svg";
export { ForwardRef as ReactComponent };